import React from "react";
import "./resume.css";
import Data from "./Data";
import Card from "./Card";
const Resume: React.FC = () => {
  return (
    <section className="resume container section" id="experience">
      <h2 className="section__title">Experience</h2>

      <div className="resume__content">
        <div className="timeline">
          {Data.filter((item) => item.category === "experience").map((item) => (
            <Card
              key={item.id}
              icon={item.icon}
              title={item.title}
              year={item.year}
              desc={item.desc}
              href={item.href}
              details={item.details}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Resume;
